export default __webpack_public_path__ + "static/media/NoDataFound.645352cb.svg";